<div #root>
    <div *ngIf="loader" style="height: 300px;">
        <loading></loading>
    </div>
    
    <div *ngIf="!loader && this.data.length==0" style="height: 300px;text-align: center;place-content: center;">
        <span style="font-size: 18px;font-family: 'Poppins';"> {{ error_name }} </span>
    </div>
    
    <div class="du-status-journey-patient-journey" *ngFor="let patient of groupedJourneys">
    
        <!-- PATIENT HEADER -->
        <div class="du-status-journey-patient-header"
            [style.border-left]="patient?.referral_source == 'HUB' ? '3px solid #FFCD4A' : patient?.referral_source == 'SP' ? '3px solid #844AFF' : ''">
            <span class="du-status-journey-patient-id">
                {{ patient.du_patient_id }}
            </span>
            <br>
            <span *ngIf="patient?.referral_source" class="du-status-journey-referral-source">
                {{ patient?.referral_source || '' }}
            </span>
        </div>
    
        <!-- TIMELINE -->
        <ul class="du-status-journey-journey-timeline">
    
            <li class="du-status-journey-journey-li" *ngFor="let stage of patient.stages; let i = index"
                [ngClass]="getStageClasses(stage, patient.stages, i)">
    
                <div class="status" [class.has-line]="i < patient.stages.length - 1">
    
                    <span class="icon" [innerHTML]="getStageIcon(stage.stage_status!)">
                    </span>
    
                    <span class="line-days" *ngIf="i < patient.stages.length - 1">
                        {{ getLineLabel(patient.stages, i) }}
                    </span>
                </div>
    
                <div class="du-status-journey-timestamp">
                    <div class="label">{{ stage.du_status_group }} <span style="color: #8A98AB"
                            *ngIf="stage.stage_status === 'success'">{{stage.status_date | date:'dd.MM'}}</span> </div>
                </div>
    
            </li>
    
        </ul>
    
    </div>
</div>